module.exports = __webpack_public_path__ + "img/project1_medium@2x.9425c917.jpg";